module.exports = __webpack_public_path__ + "static/media/maintanance---.450b2f39.jpg";